import { Chip, SxProps, useTheme } from '@mui/material';

import { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { pxToRem } from '@/theme/typography';

interface CancelTicketChipProps {
  sx?: SxProps;
}

export const CancelTicketChip: FC<CancelTicketChipProps> = ({ sx }) => {
  const theme = useTheme();

  return (
    <Chip
      component='span'
      label={<FormattedMessage id='booking.canceled' />}
      sx={{
        paddingX: '12px',
        paddingY: '5.5px',
        '& .MuiChip-label': {
          padding: '0px',
          fontSize: {
            mobile: '9px',
            tablet: pxToRem(14),
          },
          fontWeight: 400,
          lineHeight: {
            tablet: pxToRem(24),
          },
        },
        color: theme.palette.primary.main,
        backgroundColor: theme.palette.primary.light,
        ...sx,
      }}
    />
  );
};
